/* eslint-disable max-len */
import * as questionIds from "../../consultationQuestions/questionIds";

export const generalAndConsentQuestions = [
    {
        id: questionIds.AdvisedEmployeeTemporarilyUnfitToCarryOutDuties,
        questionText: "Have you advised that the employee is temporarily unfit to carry out their duties?",
    },
    {
        id: questionIds.PleaseDocumentTheReasonsForTheAboveDecision,
        questionText: "Please document the reasons for the above decision",
    },
    {
        id: questionIds.AdvisedToDiscussTemporarilyUnfitStatusWithLineManager,
        questionText: "Have you advised the employee to discuss their temporarily unfit status for their duties with their line manager immediately following this assessment?",
    },
    {
        id: questionIds.InformedCaseWillBeAssessedByOha,
        questionText: "Have you informed the employee that their case will be further assessed by an OHA who may contact them for further information or provide a statement of fitness based on what has already been collected?",
    },
    {
        id: questionIds.ConfirmIfEmployeeHasProvidedConsentToProvideInformationToEmployer,
        questionText: "Please confirm if the employee has provided consent that any specific declared medical conditions, the impact this may have on their role and adjustments that may be required can be provided to their employer",
    },
    {
        id: questionIds.ProvideDetailsOfTheConsent,
        questionText: "If Yes please provide details of the consent provided and which medical condition they are happy to share with their employer",
    },
    {
        id: questionIds.GeneralNotes,
        questionText: "Please write additional notes here or provide Further details and notes of any additional assessments and tests that you have carried out",
    },
    {
        id: questionIds.MedicalDocuments,
        questionText: "Please attach any documents relevant to the medical that have been printed out or completed by Hand",
    },
    {
        id: questionIds.AnyDocumentsSentViaPost,
        questionText: "Please tick here if other documents that have not been attached electronically are being sent by post",
    },
    {
        id: questionIds.ConsentGiven,
        questionText: "Please confirm that the employee has provided consent for information on their fitness to work as a result of this examination or medical being provided to their employer.",
    }
];
/* eslint-enable max-len */
